// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f7Hh1","label":"styles_label__1kGSX"};